module.exports = __webpack_public_path__ + "img/donante-icd.2bd8bb7f.png";